import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'

const FILL = { width: '100%', height: '100%' }

/** Pinch/drag-zoomable image that fills its container; double-tap resets. */
export function ZoomableImage({
  src,
  alt,
  maxScale = 8,
  wheel = true,
  lazy = false,
}: {
  src: string
  alt: string
  maxScale?: number
  /** Disable when the image sits inside a scrolling page, so the wheel scrolls instead of zooming. */
  wheel?: boolean
  lazy?: boolean
}) {
  return (
    <TransformWrapper minScale={1} maxScale={maxScale} doubleClick={{ mode: 'reset' }} wheel={{ disabled: !wheel }}>
      <TransformComponent wrapperStyle={FILL} contentStyle={FILL}>
        <img
          src={src}
          alt={alt}
          loading={lazy ? 'lazy' : undefined}
          className="w-full h-full object-contain"
          draggable={false}
        />
      </TransformComponent>
    </TransformWrapper>
  )
}
